export const getPaginationFromParams = (params: {}) => {
  const pageParam = (params as any)["page[number]"]
  return pageParam ? parseInt(pageParam, 10) : 1
}
